module.exports = __webpack_public_path__ + "static/media/brandSignature.ccc5ba0e.svg";